import React, { Component } from 'react';
import Map from './Map';
import Pannel from './Pannel';
import {Provider} from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import {middleware} from './lib/Action';
import './App.css';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Route, Redirect } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import getCityInfo from './lib/getCityInfo';
import {SetCity} from './actions';

const history = createBrowserHistory();
const redirect = React.createFactory(Redirect);
const router = React.createFactory(BrowserRouter);
const route = React.createFactory(Route);
const div = React.createFactory('div');
const map = React.createFactory(Map);
const pannel = React.createFactory(Pannel);
const provider = React.createFactory(Provider);
const dragDropContextProvider = React.createFactory(DragDropContextProvider);
const jsdom = navigator.userAgent.includes('Node.js'); //snapshotting

function setCity(city, store) {
  const {title, description} = getCityInfo(city);
  const metas = document.getElementsByTagName('meta');
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    const name = String(
      meta.getAttribute('name') || meta.getAttribute('property')
    );
    if (name.match('title')) {
      meta.setAttribute('content', title);
    }
    if (name.match('description')) {
      meta.setAttribute('content', description);
    }
    if (name.match('image')) {
      meta.setAttribute(
        'content',
        `https://delfrrr.github.io/strava-activities/twitter-card-${city}.png`
      );
    }
  }
  document.title = title;
  store.dispatch(new SetCity(city));
}

class App extends Component {
  render() {
    let store = createStore(reducers, {}, applyMiddleware(middleware));
    return provider(
      {store},
      router(
        {history, basename: '/strava-activities'},
        dragDropContextProvider(
          {backend: HTML5Backend},
          div(
            {className: 'App'},
            jsdom ? null : map(),
            pannel(),
            route({path: '/', exact: true, render() {
              return  redirect({to: '/berlin'});
            }}),
            route({path: '/berlin', render() {
              setCity('berlin', store);
              return null;
            }}),
            route({path: '/seattle', render() {
              setCity('seattle', store);
              return null;
            }}),
            route({path: '/brussels', render() {
              setCity('brussels', store);
              return null;
            }})
          )
        )
      )
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js